import { useState, useCallback, useEffect } from 'react';
import { createPopper } from '@popperjs/core';
import noop from 'lodash/noop';

const useCreateOptimizedPopper = (enabled: boolean) => {
  const [popper, setPopper] = useState<ReturnType<typeof createPopper>>(null);

  const createOptimizedPopper = useCallback((...args: Parameters<typeof createPopper>) => {
    const newPopper = createPopper(...args);
    setPopper(newPopper);
    return newPopper;
  }, []);

  useEffect(() => {
    if (popper) {
      const shouldRefresh = popper.state.options.modifiers.some((modifier) => (
        modifier.fn && modifier.enabled !== enabled
      ));

      if (shouldRefresh) {
        const newOptions = {
          ...popper.state.options,
          modifiers: popper.state.options.modifiers.map((modifier) => {
            if (!modifier.fn) {
              return modifier;
            }

            return ({
              ...modifier,
              enabled,
            });
          }),
        };

        popper.setOptions(newOptions).catch(noop);
      }
    }
  }, [enabled, popper]);

  return createOptimizedPopper;
};

export default useCreateOptimizedPopper;
